<template>
  <div id="wpt">
    <div class="banner">
      <BannerDetail
        mobile-url="https://website.obs.icheer.cn/icheer-web/images/WPT/wpt-banner-mobile-2.png"
        src="https://website.obs.icheer.cn/icheer-web/images/WPT/wpt-banner-20251215.png"/>
    </div>
    <div class="main">
      <div class="normal">
        <div class="introduction">
          <h3 class="title" id="a1">万品通电子产品选品平台</h3>
          <div class="content">
            <p>万品通电子产品选品平台，是为电子行业从业人员量身定制的工作伴侣。平台以实名名片交换、实时商机对接及可视化数据工具为核心，创新融合产品展示与客户双向管理，零佣金、无广告，助力源头厂商建立独立直销渠道，提升运营效率与市场竞争力；同时帮助分销电商精准对接优质供应商与潜力新品，洞察市场趋势——致力于构建一个透明、高效、可信赖的产业直联生态。
            </p>
          </div>
        </div>
        <div class="coreValue">
          <h3 class="title">核心价值</h3>
          <div class="content">
              <BgCenterToggle
                v-for="(item, i) in coreValues"
                :key="i"
                :background="item.bg"
                :centerImage="item.center"
                :index="i">
                {{ item.text }}
              </BgCenterToggle>
          </div>
        </div>
        <div id="a2"  class="padding-model"/>
        <div class="summary">
          <h3 class="title">主要功能</h3>
          <div class="content">
            <img  src="https://website.obs.icheer.cn/icheer-web/images/WPT/main-barner.png"/>
            <WptMainFunctions  center-image="https://website.obs.icheer.cn/icheer-web/images/WPT/rings-center.jpg"/>
          </div>
          <div id="a3"  class="padding-model"/>
        </div>
        <div class="reason" >
          <h3 class="title">竞争优势</h3>
          <div class="content">
            万品通为厂商提供免费、简洁无广告的B2B产品展示与私域运营平台，助力消费电子源头厂商突破传统电商依赖，通过私域流量运营建立独立销售渠道，不仅降低运营门槛，还能增强客户粘性，创造更高价值——相比传统电商平台和CRM系统，万品通兼具高效业务管理和真实客户资源，实现信息无缝对接，优化团队协作，让选品和客户管理更专注高效。
            <el-row class="compare-divider-line">
              <img width="100%" src="https://website.obs.icheer.cn/icheer-web/images/WPT/icons/diliver.png" />
            </el-row>
            <el-row class="compare-divider"><h3>VS 主流电商平台</h3></el-row>
            <div><img width="100%" src="https://website.obs.icheer.cn/icheer-web/images/WPT/advantage-banner-1.png"></div>
            <el-row class="advtages-content" :gutter="30">
              <el-col :span="8" v-for="item in advatages" :key="item" class="advtage-unit">
                <div class="title">{{item.title}}</div>
                <div class="text">{{item.text}}</div>
              </el-col>
            </el-row>
            <el-row class="compare-divider-line" >
              <img width="100%" src="https://website.obs.icheer.cn/icheer-web/images/WPT/icons/diliver.png" />
            </el-row>
            <el-row class="compare-divider"><h3>VS 传统CRM系统</h3></el-row>
            <div class="compare-advtages">
              <div class="content">
                <div class="title">{{compareAdvtages[0].title}}</div>
                <div class="text" >{{compareAdvtages[0].text}}</div>
              </div>
              <div class="compare-center-img"><img width="100%" src="https://website.obs.icheer.cn/icheer-web/images/WPT/advantage-banner-2.png" /></div>
              <div class="content">
                <div class="title">{{compareAdvtages[1].title}}</div>
                <div class="text">{{compareAdvtages[1].text}}</div>
              </div>
            </div>
            <BrandLogoBarnerFooter  class="brand-footer-wpt"/>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script setup>
import BannerDetail from './BannerDetail.vue'
import WhyChooseUs from '@/components/WhyChooseUs.vue'
import BrandLogoBarnerFooter from '@/components/BrandLogoBarnerFooter.vue'
import { watch, onMounted, ref, nextTick } from 'vue'
import WptMainFunctions from '@/components/WptMainFunctions.vue'
import { useRouter } from 'vue-router'
import BgCenterToggle from '@/components/BgCenterToggle.vue'
const hoverIndex = ref(null) // 当前悬停的索引，null 表示没有悬
const coreValues = [
  {
    bg: 'https://website.obs.icheer.cn/icheer-web/images/WPT/core-value-001-bg.png',
    center: 'https://website.obs.icheer.cn/icheer-web/images/WPT/core-center-01.jpg',
    text: '对源头厂商的价值：助力品牌曝光与新品推广，拓展客户资源，持续维系和深化客户关系，提升市场竞争力。'
  },
  {
    bg: 'https://website.obs.icheer.cn/icheer-web/images/WPT/core-value-002-bg.png',
    center: 'https://website.obs.icheer.cn/icheer-web/images/WPT/core-center-02.jpg',
    text: '对分销电商的价值：获取源头优质产品与供应商信息，洞察行业热点与产品趋势，为选品决策和市场布局提供支持。'
  },
  {
    bg: 'https://website.obs.icheer.cn/icheer-web/images/WPT/core-value-003-bg.png',
    center: 'https://website.obs.icheer.cn/icheer-web/images/WPT/core-center-03.jpg',
    text: '对易客创新的价值：依托平台丰富数据，精准把握市场行情与最新需求，为易客战略客户提供定制化产品升级与创新解决方案。'
  },
  {
    bg: 'https://website.obs.icheer.cn/icheer-web/images/WPT/core-value-004-bg.png',
    center: 'https://website.obs.icheer.cn/icheer-web/images/WPT/core-center-04.jpg',
    text: '对电子行业的价值：构建透明、高效、可信的交易生态，促进产业链上下游协同创新，推动电子行业结构优化与业态升级。'
  }
]
const coreValueImgs = [
  {
    default: 'https://website.obs.icheer.cn/icheer-web/images/WPT/core-value-001.png',
    hover: 'https://website.obs.icheer.cn/icheer-web/images/WPT/core-value-001-bg.png'
  },
  {
    default: 'https://website.obs.icheer.cn/icheer-web/images/WPT/core-value-002.png',
    hover: 'https://website.obs.icheer.cn/icheer-web/images/WPT/core-value-002-bg.png'
  },
  {
    default: 'https://website.obs.icheer.cn/icheer-web/images/WPT/core-value-003.png',
    hover: 'https://website.obs.icheer.cn/icheer-web/images/WPT/core-value-003-bg.png'
  },
  {
    default: 'https://website.obs.icheer.cn/icheer-web/images/WPT/core-value-004.png',
    hover: 'https://website.obs.icheer.cn/icheer-web/images/WPT/core-value-004-bg.png'
  }
]
const advatages = [
  {
    title: '零佣金',
    text: '所有功能均免费使用，为厂商提供零成本产品展示平台，大幅降低运营门槛、增强用户使用率与活跃度。'
  },
  {
    title: '无广告',
    text: '小程序界面简洁无广告，聚焦产品展示，杜绝广告和干扰信息，优化选品体验，提升运营效率。'
  }, {
    title: '建直渠',
    text: '专注B2B市场，帮助厂商在主流电商平台之外建立独立直销渠道，分流销售压力，提升利润空间。'
  }
]
const compareAdvtages = [
  {
    title: '产品客户双向管理',
    text: '创新融合产品展示与实名名片交换功能，企业可实时掌握员工拓展的客户资源；所有客户均经手机号、姓名实名认证，确保信息真实可靠。'
  },
  {
    title: '业务信息无缝流转',
    text: '员工可在聊天窗口直接汇报客户沟通进展，企业管理者随时查看，实现信息无缝流转，避免业务断档，提升团队协作效率。'
  }
]
const $router = useRouter()
onMounted(() => {
  nextTick(() => window.dispatchEvent(new Event('resize')))
  watch(() => $router.currentRoute.value.query, (newValue, oldValue) => {
    const arch = $router.currentRoute.value.query.arch
    if (arch == null) return
    const target = document.querySelector(`#${arch}`)
    target.scrollIntoView({
      behavior: 'smooth'
    })
  }, { immediate: true })
})
</script>
<style>
#wpt {
  width: 100%;
  height: auto;
  min-width: 375px;
}

#wpt>.banner, #wpt>.main {
  width: 100%;
  height: auto;
  min-width: 375px;
  margin: 0 auto;
}

wpt>.main{
  padding-top: 1.8vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

#wpt>.main>.normal{
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#wpt>.main>.normal>.introduction{
  width: 52.04vw;
  height: auto;
  margin-bottom: 0.8vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#wpt>.main>.normal>.introduction>.title{
  font-size: 1.58vw;
  letter-spacing: -0.015vw;
  margin-bottom: 0.66vw;
}

#wpt>.main>.normal>.introduction>.content {
  width: 100%;
  height: auto;
  font-size: 0.93vw;
  letter-spacing: -0.002vw;
  line-height: 1.82vw;
}

#wpt>.main>.normal>.introduction>.content img{
  width: 100%;
  height: auto;
  object-fit: contain;
  margin-bottom: -0.35vw;
}

#wpt>.main>.normal>.process{
  width: 52.04vw;
  height: 16vw;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center
}
#wpt>.main>.normal>.coreValue{
  width: 52.04vw;
  height: 22vw;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center
}
#wpt>.main>.normal>.coreValue>.title{
  font-size: 1.58vw;
  letter-spacing: -0.015vw;
  margin-bottom: 1.5vw;
}
#wpt>.main>.normal>.coreValue>.content{
  width: 100%;
  height: 19vw;
  margin-top: 1vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2vw;
}
#wpt>.main>.normal>.coreValue>.content>.unit {
  width: 20%;
  height: 100%;
  cursor: pointer;

}
#wpt>.main>.normal>.coreValue>.content>.unit .coreImgs{
  cursor: pointer;
  width: 100%;
}
#wpt>.main>.normal>.process>.title{
  font-size: 1.58vw;
  letter-spacing: -0.015vw;
}

#wpt>.main>.normal>.process>.content{
  width: 100%;
  height: 12vw;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center
}

#wpt>.main>.normal>.process .unit{
  width: 8.85vw;
  height: 8.85vw;
  position: relative;
  display: flex;
  justify-content: center
}

#wpt>.main>.normal>.process .unit p{
  font-size: 0.94vw;
  position: absolute;
  top: 5.95vw
}

#wpt>.main>.normal>.process .unit img{
  border-radius: 0.5vw
}

#wpt>.main>.normal>.process .temp{
  width: 2vw;
  height: 2vw;
  display: flex;
  margin-left: 1.75vw;
  margin-right: 1.75vw
}

#wpt>.main>.normal>.summary{
  width: 52vw;
  height: 55vw;
  margin-bottom: 2vw;
  display: flex;
  flex-direction: column;
  align-items: center
}

#wpt>.main>.normal>.summary>.title{
  font-size: 1.55vw;
  letter-spacing: 0.01vw;
  margin-bottom: 1.2vw
}

#wpt>.main>.normal>.summary>.content{
  width: 100%;
  height: 50vw;
  font-size: 0.94vw;
  line-height: 1.85vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#wpt>.main>.normal>.summary>.content>.app-container{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f5f7fa;
  padding: 50px 0;
}
#wpt>.main>.normal>.summary>.content img{
  width: 100%;
  max-height: 100%;
  border-radius: 0.5vw;
  object-fit: contain;
  margin-top: 1vw
}
#wpt>.main>.normal>.padding-model{
  height: 2vw;
}
#wpt>.main>.normal>.reason{
  width: 52.04vw;
  height: 60vw;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center
}

#wpt>.main>.normal>.reason .title{
  width: 100%;
  margin: 1.55vw 0 1.55vw 0;
  font-size: 1.57vw;
  text-align: center
}

#wpt>.main>.normal>.reason>.content{
  width: 100%;
  height: 60vw;
  font-size: 0.94vw;
  line-height: 1.85vw;
  display: flex;
  flex-direction: column;
  align-items: center;

}
#wpt>.main>.normal>.reason>.content>.advtages-content>.advtage-unit{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
#wpt>.main>.normal>.reason>.content>.advtages-content>.advtage-unit>.title{
  font-weight: bold;
  font-size: 1.3vw;
}
#wpt>.main>.normal>.reason>.content>.advtages-content>.advtage-unit:hover{
  .title{
    color: #2ca6e0;
  }
  .text{
    color: black;
  }
}
#wpt>.main>.normal>.reason>.content>.advtages-content>.advtage-unit>.text{
  width: 80%;
  font-size: 0.8vw;
  color: #868686;
  margin-top: -1.5vw;
}
#wpt>.main>.normal>.reason>.content>.compare-divider-line{
  margin-top: 1vw;
}
#wpt>.main>.normal>.reason>.content>.compare-divider{
  margin-top: -3vw;
}
#wpt>.main>.normal>.reason>.content>.compare-divider h3{
 font-weight: normal;
 font-size: 1.2vw;
}
#wpt>.main>.normal>.reason>.content>.compare-advtages{
  background-color: #F2F2F2;
  height: 13vw;
  width: 100%;
  border-radius: 0  0  2vw 2vw;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: space-around;
  .compare-center-img{
    width: 30%;
  }
  .content{
    width: 35%;
    height: 12vw;
    overflow: hidden;
    padding: 1vw;
    cursor: pointer;
    .title{
      font-size: 1.3vw;
      font-weight: bold;
      text-align: center;
    }
    .text{
      font-size: 0.8vw;
      color: #868686;
    }
  }
}
#wpt>.main>.normal>.reason>.content>.compare-advtages>.content:hover{
  .title{
    color: #2ca6e0;
  }
  .text{
    color: black;
  }
}
#wpt>.main>.normal>.reason .brand-footer-wpt{
  width: 90%;
  border: none;
}
#wpt>.main>.normal>.reason>.content>.divider{
  margin-top: 1 vw;
  margin-bottom: 1 vw;
}
#wpt>.main>.normal>.reason>.content>.divider>.divider-title{
  font-weight: 500;
  font-size: 1.1vw;
}
/* ========== 移动端增量 @media ========== */
@media (max-width: 768px) {
  /* 根字号放大，阅读舒适（可选） */
  html { font-size: 4.2667vw; } /* 375px 下 ≈ 16px */
  /* 全局留白 */
  #wpt > .main > .normal > * { width: 92% !important; }

  /* 介绍 */
  #wpt > .main > .normal > .introduction > .title { font-size: 1rem; }
  #wpt > .main > .normal > .introduction > .content { font-size: 0.75rem; line-height: 1.6; }

  /* 核心价值 4→2 列 */

  #wpt > .main > .normal > .coreValue > .title{ font-size: 1rem}
  #wpt > .main > .normal > .coreValue{
    height: 43vw;
    .content{
      height: 35vw;
    }
  }
  /* 主要功能 4→2 列 */
  #wpt>.main>.normal>.summary >.title{font-size: 1rem}
  #wpt>.main>.normal>.summary{height: 140vw;}
  #wpt>.main>.normal>.summary>.content{height: 140vw;}

  /* 主要功能圆环上下布局
  .main-container { flex-direction: column; }
  .content-col { width: 100% !important; }
  .ring-col { width: 100% !important; margin: 1rem 0; }*/

  /* 优势对比 3→1 列 */
  #wpt>.main>.normal>.reason{height: 145vw;}
  #wpt>.main>.normal>.reason>.title{font-size: 1rem}
  #wpt>.main>.normal>.reason>.content{
    height: 135vw;
    font-size: 0.75rem;
    line-height: 1.6;
  }
  /* 隐藏过密虚线
  .dash-line-svg { display: none; }*/

  /* 图片自适应 */
  img { max-width: 100%; height: auto; }
  #wpt>.main>.normal>.reason>.content>.compare-divider-line{
    margin-top: 2vw;
  }
  #wpt>.main>.normal>.reason>.content>.compare-divider{
    margin-top: -1.35rem;
  }
  #wpt>.main>.normal>.reason>.content>.compare-divider h3{
    font-weight: normal;
    font-size: 0.6rem;
  }
  #wpt>.main>.normal>.reason>.content>.compare-advtages{
    height: 25vw;
    border-radius: 0  0  2vw 2vw;
    margin-bottom: 0px;
    .compare-center-img{
      width: 28%;
    }
    .content{
      width: 38%;
      height: 24vw;
      overflow: hidden;
      padding: 1vw;
      cursor: pointer;
      .title{
        font-size: 0.6rem;
        font-weight: bold;
        text-align: center;
      }
      .text{
        font-size: 0.35rem;
        color: #868686;
      }
    }
  }
  #wpt>.main>.normal>.reason>.content>.brand-footer-wpt{
    width: 100%;
    margin-top: 1vw;
  }
  #wpt>.main>.normal>.reason>.content>.advtages-content>.advtage-unit>.title{
    font-size: 0.5rem;
  }
  #wpt>.main>.normal>.reason>.content>.advtages-content>.advtage-unit>.text{
    width: 85%;
    font-size: 0.4rem;
  }
}
</style>
